import { API_GETDASHBOARD, AUTH_SESSION } from "../constants";
import { axiosGet, getAuthorization } from "../utils/axios";


const DashboardApi = {
  getDashBoard: async () => {

    const headers = {
      ...getAuthorization(AUTH_SESSION),
    };

    return await axiosGet(API_GETDASHBOARD, {}, headers)
      .then((res) => res.data.data)
      .catch((error) => {
        console.error("Error fetching dashboard data:", error);
        return error.response.data;
      });
  },
};

export default DashboardApi;
